export const FinancesActionTypes = {
    ASYNC_ENTRIES_DATA: '@finances/ASYNC_ENTRIES_DATA',
    CHANGE_ENTRIES_DATA: '@finances/CHANGE_ENTRIES_DATA',
    APPEND_ENTRIES_DATA: '@finances/APPEND_ENTRIES_DATA',
    ASYNC_BALANCE: '@finances/ASYNC_BALANCE',
    CHANGE_BALANCE: '@finances/CHANGE_BALANCE',
    CHANGE_LOADING: '@finances/CHANGE_LOADING',
    CHANGE_LOADING_MORE: '@finances/CHANGE_LOADING_MORE',
    CHANGE_BALANCE_LOADING: '@finances/CHANGE_BALANCE_LOADING',
    CHANGE_WITHDRAW_LOADING: '@finances/CHANGE_WITHDRAW_LOADING',
    ASYNC_ALL_WITHDRAW: '@finances/ASYNC_ALL_WITHDRAW',
  };

  const INITIAL_DATA = {
    entries: [],
    page: 0,
    page_size: 0,
    total_pages: 0,
    total_entries: 0,
  };

  const INITIAL_STATE = {
    data: INITIAL_DATA,
    balance: null,
    balanceLoading: true,
    loading: false,
    loadingMore: false,
    withdrawLoading: false,
  };

  export const changeLoading = (payload) => ({type: FinancesActionTypes.CHANGE_LOADING, payload});
  export const changeLoadingMore = (payload) => ({type: FinancesActionTypes.CHANGE_LOADING_MORE, payload});
  export const changeBalanceLoading = (payload) => ({type: FinancesActionTypes.CHANGE_BALANCE_LOADING, payload});
  export const changeWithdrawLoading = (payload) => ({type: FinancesActionTypes.CHANGE_WITHDRAW_LOADING, payload});

  export const asyncEntriesData = (payload) => ({
      type: FinancesActionTypes.ASYNC_ENTRIES_DATA,
      payload,
  });

  export const changeEntriesData = (data) => ({
      type: FinancesActionTypes.CHANGE_ENTRIES_DATA,
      payload: data,
  });

  export const appendEntriesData = (data) => ({
      type: FinancesActionTypes.APPEND_ENTRIES_DATA,
      payload: data,
  });

  export const asyncBalance = (payload) => ({
      type: FinancesActionTypes.ASYNC_BALANCE,
      payload,
  });

  export const changeBalance = (payload) => ({
      type: FinancesActionTypes.CHANGE_BALANCE,
      payload,
  });

  export const asyncAllWithdraw = () => ({
      type: FinancesActionTypes.ASYNC_ALL_WITHDRAW,
  });

  export class FinancesSelectors {
    static loading({Finances}) {
      return Finances?.loading;
    }

    static loadingMore({Finances}) {
      return Finances?.loadingMore;
    }

    static entriesData({Finances}) {
      return Finances?.data;
    }

    static hasMore({Finances}) {
      const data = Finances?.data;
      if (!data) return false;
      return (data.entries?.length || 0) < (data.total_entries || 0);
    }

    static balance({Finances}) {
      return Finances?.balance;
    }

    static balanceLoading({Finances}) {
      return Finances?.balanceLoading;
    }

    static withdrawLoading({Finances}) {
      return Finances?.withdrawLoading;
    }
  }

  function FinancesReducer(state = INITIAL_STATE, {type, payload}) {
    switch (type) {
    case FinancesActionTypes.CHANGE_LOADING:
      return {...state, loading: payload};
    case FinancesActionTypes.CHANGE_LOADING_MORE:
      return {...state, loadingMore: payload};
    case FinancesActionTypes.CHANGE_BALANCE_LOADING:
      return {...state, balanceLoading: payload};
    case FinancesActionTypes.CHANGE_WITHDRAW_LOADING:
      return {...state, withdrawLoading: payload};
    case FinancesActionTypes.CHANGE_ENTRIES_DATA:
      return {...state, data: payload};
    case FinancesActionTypes.APPEND_ENTRIES_DATA:
      return {
        ...state,
        data: {
          ...payload,
          entries: [...(state.data?.entries || []), ...(payload.entries || [])],
        },
      };
    case FinancesActionTypes.CHANGE_BALANCE:
      return {...state, balance: payload};

    default:
      return state;
    }
  }

  export default FinancesReducer;
